import { useAtom } from '@reatom/npm-react'
import styled, { css } from 'styled-components'

import { ArrowLeftIcon } from '@blade/ui-kit'
import { PairInformationCurrency } from '@root/entities/pair/ui'
import { PairIcon } from '@root/entities/pair/ui/common'
import { PairInformationFavorite } from '@root/features/favorite-pairs/ui/desktop'
import { PnLShareDialogButton } from '@root/features/trade/position/pnl-position-share/ui/pnl-position-share-dialog-button'
import { activePairPositionAtom } from '@root/features/trade/trading/atoms'
import { mediaMaxDesktopSmall } from '@root/shared/ui-kit'

import { PairInformationPool } from './pair-information-pool'

import type { PairModel } from '@root/entities/pair/atoms/reatom-pair'
import type { ClassNameProps } from '@root/shared/react'

type PairInformationProps = {
  pair: PairModel
  onAuditClick?: () => void
  onBack?: () => void
  onDevTokensClick: () => void
} & ClassNameProps

export const PairInformation: React.FC<PairInformationProps> = ({
  className,
  pair,
  onAuditClick,
  onBack,
  onDevTokensClick,
}) => {
  const [position] = useAtom(activePairPositionAtom)

  return (
    <PairInformationRoot className={className}>
      <BackButton onClick={onBack}>
        <ArrowLeftIcon size={20} />
      </BackButton>
      <PairInformationFavorite
        pair={pair}
        css={css`
          margin-inline-start: 4px;
          margin-inline-end: 10px;
        `}
      />
      <PairIcon
        size={40}
        pair={pair}
        withNetwork
        providerSize={14}
        reusedImages={{ side: 'right' }}
      />
      <PairInformationCurrencySlot>
        <PairInformationCurrency
          pair={pair}
          withSocials
          withAge
          withShare
          withProvider
          withBoosters
          withDevTokens
          withTitleOverflow
          withDevBurn
          tickerAsLink={false}
          onDevTokensClick={onDevTokensClick}
        />
      </PairInformationCurrencySlot>
      {position ? (
        <PnlButtonContainer>
          <PnLShareDialogButton position={position} pair={pair} />
        </PnlButtonContainer>
      ) : (
        <div />
      )}
      <PairInformationPool
        onAuditClick={onAuditClick}
        pair={pair}
        withPrice
        withAudit
        withAuditChecks
        withFees
      />
    </PairInformationRoot>
  )
}

const BackButton = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;
  height: 20px;
  color: var(--text-9);
  border-inline-end: 1px solid var(--background-2);
  cursor: pointer;
  padding-inline: 4px;
  margin-inline-end: 2px;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: var(--text-11);
  }
`

export const PairInformationCurrencySlot = styled.div`
  padding-inline: 8px;
`
export const PairInformationRoot = styled.div`
  border-bottom: 1px solid var(--background-3);

  height: 64px;
  display: grid;
  justify-items: start;
  align-items: center;
  grid-template-columns: auto auto auto auto auto 1fr;
  padding-inline: 8px 16px;

  ${mediaMaxDesktopSmall(css`
    padding-inline: 6px;
  `)}
`

const PnlButtonContainer = styled.div`
  height: 100%;
  display: grid;
  align-items: center;
  padding-inline-start: 8px;
  margin-top: 9px;
`
